module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "15",
      "height": "14",
      "viewBox": "0 0 15 14",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13.7194 11.3799H12.7587C12.6837 11.3799 12.6212 11.4424 12.6212 11.5174V12.621H1.37652V1.37455H12.623V2.47813C12.623 2.55313 12.6855 2.61563 12.7605 2.61563H13.7212C13.7962 2.61563 13.8587 2.55491 13.8587 2.47813V0.688839C13.8587 0.385268 13.614 0.140625 13.3105 0.140625H0.690808C0.387236 0.140625 0.142593 0.385268 0.142593 0.688839V13.3067C0.142593 13.6103 0.387236 13.8549 0.690808 13.8549H13.3087C13.6122 13.8549 13.8569 13.6103 13.8569 13.3067V11.5174C13.8569 11.4406 13.7944 11.3799 13.7194 11.3799ZM14.0515 6.88527L11.5176 4.88527C11.423 4.81027 11.2855 4.87813 11.2855 4.99777V6.35491H5.67831C5.59974 6.35491 5.53545 6.4192 5.53545 6.49777V7.49777C5.53545 7.57634 5.59974 7.64063 5.67831 7.64063H11.2855V8.99777C11.2855 9.11741 11.4247 9.18527 11.5176 9.11027L14.0515 7.11027C14.0686 7.09691 14.0824 7.07983 14.0919 7.06034C14.1014 7.04085 14.1063 7.01945 14.1063 6.99777C14.1063 6.97609 14.1014 6.95469 14.0919 6.9352C14.0824 6.91571 14.0686 6.89863 14.0515 6.88527Z",
      "fill": "black",
      "fill-opacity": "0.85"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2534b110"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/export.vue
// module id = 1481
// module chunks = 159